import { i18n } from '../services/i18n.js';
import { dbSim } from '../services/dbSim.js';
import { escapeHTML } from '../services/sanitize.js';
import { icon } from '../services/icons.js';

export const DashboardView = container => {
  if (!localStorage.getItem('h150_auth_user')) { window.location.hash = '#/login'; return; }

  const render = async () => {
    const games = await dbSim.getGames();
    const sessions = (await dbSim.getSessions()).filter(session => session.status === 'finished' && session.mode === 'live' && session.participantsCount >= 5);
    const brand = await dbSim.getBrand().catch(() => ({ name: '', tagline: '', revision: -1 }));
    const hasBrand = brand.revision >= 0 && Boolean(brand.name?.trim());
    const brandName = hasBrand ? brand.name : i18n.t('brand_default_name');
    const brandTagline = hasBrand && brand.tagline?.trim() ? brand.tagline : i18n.t('brand_default_tagline');
    const canPin = games.length >= 5;
    const totalQuestions = games.reduce((sum, game) => sum + game.questions.length, 0);

    container.innerHTML = `<main class="host-dashboard-v2">
      <div class="container">
        <header class="host-dashboard-head">
          <a href="#/games/new" class="btn btn-primary">${icon('plus')} ${i18n.t('create_game')}</a>
        </header>

        <section class="host-quick-stats" aria-label="${i18n.t('dashboard_overview')}">
          <div><span>${i18n.t('recent_games')}</span><strong>${games.length}</strong></div>
          <div><span>${i18n.t('questions')}</span><strong>${totalQuestions}</strong></div>
          <div><span>${i18n.t('completed_sessions')}</span><strong>${sessions.length}</strong></div>
        </section>

        <div class="host-dashboard-grid">
          <section class="host-library">
            <div class="host-section-head"><div><h2>${i18n.t('quiz_library')}</h2><p>${i18n.t('quiz_library_help')}</p></div><span>${games.length}</span></div>
            ${games.length === 0 ? `<div class="host-empty"><span>${icon('sparkles')}</span><h3>${i18n.t('no_games')}</h3><a href="#/games/new" class="btn btn-primary">${i18n.t('create_game')}</a></div>` : `<div class="quiz-list-v2">${games.map(game => `
              <article class="quiz-card-v2 ${game.pinned ? 'is-pinned' : ''}">
                <img src="${game.coverImage || 'assets/game_cover.png'}" alt="${escapeHTML(game.title)}">
                <div class="quiz-card-body">
                  <div class="quiz-title-row"><h3>${escapeHTML(game.title)}</h3>${game.pinned ? `<span class="quiz-pin-label">${icon('pin')} ${i18n.t('pinned')}</span>` : ''}</div>
                  <p>${escapeHTML(game.description || i18n.t('no_description'))}</p>
                  <span class="quiz-meta">${game.questions.length} ${i18n.t('questions')}</span>
                </div>
                <div class="quiz-actions-v2">
                  <a href="#/games/${game.id}" class="quiz-icon-btn" aria-label="${i18n.t('view_quiz_details')}" title="${i18n.t('view_quiz_details')}">${icon('arrowRight')}</a>
                  ${canPin ? `<button class="quiz-icon-btn pin-btn ${game.pinned ? 'active' : ''}" data-id="${game.id}" data-pinned="${game.pinned}" aria-label="${i18n.t(game.pinned ? 'unpin_quiz' : 'pin_quiz')}" title="${i18n.t(game.pinned ? 'unpin_quiz' : 'pin_quiz')}">${icon('pin')}</button>` : ''}
                </div>
              </article>`).join('')}</div>`}
          </section>

          <div class="host-right-rail">
            <section class="host-brand-card" aria-labelledby="dashboardBrandTitle">
              <div class="host-brand-mark">${escapeHTML(brandName.trim().charAt(0).toUpperCase() || 'B')}</div>
              <span>${i18n.t('brand_title')}</span>
              <h2 id="dashboardBrandTitle">${escapeHTML(brandName)}</h2>
              <p>${escapeHTML(brandTagline)}</p>
              <a href="#/settings" class="btn btn-secondary">${icon('cog')} ${i18n.t(hasBrand ? 'edit_brand' : 'setup_brand')}</a>
            </section>
            <aside class="host-history-v2">
              <div class="host-section-head"><div><h2>${i18n.t('session_history')}</h2><p>${i18n.t('session_history_help')}</p></div></div>
              ${sessions.length === 0 ? `<div class="history-empty">${icon('clock')}<p>${i18n.t('no_sessions')}</p></div>` : `<div class="history-list-v2">${sessions.slice(0, 8).map(session => {
                const game = games.find(item => item.id === session.gameId) || { title: session.gameTitle || i18n.t('deleted_game') };
                return `<a href="#/reports/${session.id}"><div><strong>${escapeHTML(game.title)}</strong><span>${new Date(session.finishedAt || session.createdAt).toLocaleDateString(i18n.getLang() === 'vi' ? 'vi-VN' : 'en-US')}</span></div><small>${session.participantsCount} ${i18n.t('players')} ${icon('arrowRight')}</small></a>`;
              }).join('')}</div>`}
            </aside>
          </div>
        </div>
      </div>
    </main>`;

    container.querySelectorAll('.pin-btn').forEach(button => button.addEventListener('click', async event => {
      const pinned = event.currentTarget.dataset.pinned === 'true';
      try { await dbSim.setGamePinned(event.currentTarget.dataset.id, !pinned); window.showToast(i18n.t(pinned ? 'quiz_unpinned' : 'quiz_pinned')); render(); }
      catch (error) { window.showToast(error.message); }
    }));
  };
  render();
};
